module.exports = __webpack_public_path__ + "img/1-3.a0ce825d.svg";